import { render, staticRenderFns } from "./videoPlayer.vue?vue&type=template&id=58f7fb2f&scoped=true&"
import script from "./videoPlayer.vue?vue&type=script&lang=ts&"
export * from "./videoPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./videoPlayer.vue?vue&type=style&index=0&id=58f7fb2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f7fb2f",
  null
  
)

export default component.exports